export var financialRelease = {
  state: {
    lancamentos: [],
    isEditing: {
      edit: false,
      nextRoute: ''
    },
    nextTab: true
  },
  getters: {
    getLanc: function getLanc(state) {
      return state.lancamentos;
    },
    getIsEditing: function getIsEditing(state) {
      return state.isEditing;
    },
    getNextTab: function getNextTab(state) {
      return state.nextTab;
    }
  },
  mutations: {
    addLanc: function addLanc(state, payload) {
      state.lancamentos.push(payload);
    },
    clearLanc: function clearLanc(state) {
      state.lancamentos = [];
    },
    setEditing: function setEditing(state, url) {
      state.isEditing.edit = true;
      state.isEditing.nextRoute = url;
    },
    setNoEditing: function setNoEditing(state) {
      state.isEditing.edit = false;
    },
    setNextTab: function setNextTab(state) {
      state.nextTab = true;
    },
    setNoNextTab: function setNoNextTab(state) {
      state.nextTab = false;
    }
  },
  actions: {}
};